import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=1a834523&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a834523",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a834523')) {
      api.createRecord('1a834523', component.options)
    } else {
      api.reload('1a834523', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=1a834523&scoped=true&", function () {
      api.rerender('1a834523', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Auth/Ukraine/Register.vue"
export default component.exports